import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { logout } from '../utils/auth';
import { isAnalyticsUser } from '../config/api';

// All nav items
const NAV_ITEMS = [
  { path: '/live-review', label: 'Live Review', icon: 'M15 10l4-3v10l-4-3M4 6h11v12H4z' },
  { path: '/bulk-review', label: 'Bulk Review', icon: 'M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z' },
  { path: '/appeals', label: 'Appeals', icon: 'M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z' },
  { path: '/videos', label: 'Videos', icon: 'M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z' },
  { path: '/reports', label: 'Reports', icon: 'M9 2a1 1 0 000 2h2a1 1 0 100-2H9z' },
  { path: '/notifications', label: 'Notifications', icon: 'M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z' },
  { path: '/campaigns', label: 'Campaigns', icon: 'M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3z' },
  { path: '/announcements', label: 'Announcements', icon: 'M18 3a1 1 0 00-1.196-.98l-10 3A1 1 0 006 6v2H5a2 2 0 00-2 2v2a2 2 0 002 2h1v1a1 1 0 002 0v-1h1.22l7.584 2.275A1 1 0 0018 16V3zM5 10h2v2H5v-2z' },
  { path: '/image-moderation', label: 'AI Moderation', icon: 'M10 1.944A11.954 11.954 0 012.166 5C2.056 5.649 2 6.319 2 7c0 5.225 3.34 9.67 8 11.317C14.66 16.67 18 12.225 18 7c0-.682-.057-1.35-.166-2.001A11.954 11.954 0 0110 1.944z' },
  { path: '/exclusive-members', label: 'Exclusive', icon: 'M10 2a4 4 0 100 8 4 4 0 000-8zM3 16a7 7 0 1114 0H3z' },
  { path: '/live-access', label: 'Live Access', icon: 'M10 2a4 4 0 100 8 4 4 0 000-8zM5.293 11.293a1 1 0 011.414 0L10 14.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z' },
  { path: '/cashout', label: 'Cashout', icon: 'M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z' },
  { path: '/growth-audit', label: 'Growth Review', icon: 'M2 3h16v14H2V3zm3 10 3-3 2 2 4-5 2 2' },
  { path: '/ai-support', label: 'AI Support', icon: 'M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7z' },
  { path: '/facebook-deletion', label: 'FB Deletion', icon: 'M9 2a1 1 0 00-.894.553L6.382 6H4a1 1 0 000 2h1l1 8a2 2 0 002 2h4a2 2 0 002-2l1-8h1a1 1 0 100-2h-2.382l-1.724-3.447A1 1 0 0011 2H9z' },
];

const ANALYTICS_ICON = 'M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z';

const RECENT_KEY = 'pingtop_recent_pages';
const MAX_RECENT = 4;

function getRecentPages(): string[] {
  try {
    const saved = localStorage.getItem(RECENT_KEY);
    return saved ? JSON.parse(saved) : [];
  } catch { return []; }
}

// Normalize any in-section route (e.g. /live-access/users/abc) back to its
// top-level nav item path (/live-access). Keeps recent pages section-scoped
// so sub-route navigation doesn't evict unrelated items or duplicate entries.
function normalizePath(path: string): string {
  const match = NAV_ITEMS.find((item) => path === item.path || path.startsWith(item.path + '/'));
  return match ? match.path : path;
}

function addRecentPage(path: string) {
  const normalized = normalizePath(path);
  const recent = getRecentPages().filter((p) => p !== normalized);
  recent.unshift(normalized);
  localStorage.setItem(RECENT_KEY, JSON.stringify(recent.slice(0, MAX_RECENT)));
}

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isLoginPage = location.pathname === '/';
  const showAnalytics = isAnalyticsUser();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [recentPages, setRecentPages] = useState<string[]>([]);

  const allItems = [
    ...NAV_ITEMS,
    ...(showAnalytics ? [
      { path: '/analytics', label: 'Analytics (Classic)', icon: ANALYTICS_ICON },
      { path: '/analytics-v2', label: 'Analytics V2', icon: ANALYTICS_ICON },
    ] : []),
  ];

  // Track page visits
  useEffect(() => {
    if (!isLoginPage && location.pathname !== '/dashboard') {
      addRecentPage(location.pathname);
      setRecentPages(getRecentPages());
    }
  }, [location.pathname, isLoginPage]);

  // Load recent on mount
  useEffect(() => { setRecentPages(getRecentPages()); }, []);

  if (isLoginPage) return null;

  const isActive = (path: string) => {
    // Exact match for analytics pages to avoid /analytics matching /analytics-v2
    if (path === '/analytics' || path === '/analytics-v2') return location.pathname === path;
    if (path === location.pathname) return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  const handleNav = (path: string) => {
    navigate(path);
    setSidebarOpen(false);
  };

  const findItem = (path: string) => allItems.find(item => item.path === path) || allItems.find(item => path.startsWith(item.path));

  // Recent items for top bar (easy access).
  // Dedupe by the resolved nav-item path: different sub-routes under the
  // same section (e.g. /live-access, /live-access/users/abc) all resolve to
  // the same top-level item and must only appear once in the header.
  const seenPaths = new Set<string>();
  const recentItems: NonNullable<ReturnType<typeof findItem>>[] = [];
  for (const path of recentPages) {
    const item = findItem(path);
    if (!item || seenPaths.has(item.path)) continue;
    seenPaths.add(item.path);
    recentItems.push(item);
    if (recentItems.length >= MAX_RECENT) break;
  }

  return (
    <>
      {/* Slim top bar */}
      <div className='sticky top-0 bg-white border-b shadow-sm z-50'>
        <div className='flex items-center gap-2 sm:gap-3 px-3 sm:px-4 py-2 max-w-[1600px] mx-auto'>
          {/* Logo */}
          <button onClick={() => navigate('/dashboard')} className='text-lg font-bold hover:opacity-80 transition-opacity flex-shrink-0'>
            <span className='bg-gradient-to-r from-[#FF9C15] to-[#F42026] bg-clip-text text-transparent'>PingTop</span>
          </button>

          {/* Divider */}
          <div className='w-px h-6 bg-gray-200 flex-shrink-0' />

          {/* Fast access — last 4 used, single horizontally-scrollable line */}
          <div className='flex items-center gap-1.5 overflow-x-auto flex-1 min-w-0'>
            {recentItems.map(item => (
              <button
                key={item.path}
                onClick={() => handleNav(item.path)}
                className={`flex items-center gap-1.5 px-2.5 sm:px-3 py-1.5 rounded-full text-xs font-semibold whitespace-nowrap transition-all flex-shrink-0 ${
                  isActive(item.path)
                    ? 'bg-gradient-to-r from-[#FF9C15] to-[#F42026] text-white shadow-sm'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                <svg className='w-3.5 h-3.5 flex-shrink-0' fill='currentColor' viewBox='0 0 20 20'>
                  <path d={item.icon} fillRule='evenodd' clipRule='evenodd' />
                </svg>
                {item.label}
              </button>
            ))}
            {recentItems.length === 0 && (
              <span className='hidden sm:inline text-xs text-gray-400 italic'>Navigate to pages to see your recent items here</span>
            )}
          </div>

          {/* Logout — hidden on mobile (still reachable from the sidebar drawer) */}
          <button
            onClick={() => { logout(); navigate('/'); }}
            className='hidden sm:flex items-center gap-1.5 px-3 py-1.5 bg-red-500 hover:bg-red-600 text-white text-xs font-semibold rounded-lg transition-colors flex-shrink-0'
          >
            <svg className='w-3.5 h-3.5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
              <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1' />
            </svg>
            Logout
          </button>

          {/* Hamburger — now on the right; opens the full page list drawer */}
          <button
            onClick={() => setSidebarOpen(true)}
            aria-label='Open menu'
            className='p-2 rounded-lg hover:bg-gray-100 transition-colors flex-shrink-0'
          >
            <svg className='w-5 h-5 text-gray-700' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
              <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M4 6h16M4 12h16M4 18h16' />
            </svg>
          </button>
        </div>
      </div>

      {/* Right sidebar overlay — slides in from the same side as the hamburger */}
      {sidebarOpen && (
        <div className='fixed inset-0 z-[60]' onClick={() => setSidebarOpen(false)}>
          {/* Backdrop */}
          <div className='absolute inset-0 bg-black/30' />

          {/* Sidebar panel */}
          <div
            className='absolute right-0 top-0 bottom-0 w-72 max-w-[85vw] bg-white shadow-2xl overflow-y-auto'
            onClick={e => e.stopPropagation()}
          >
            {/* Sidebar header */}
            <div className='flex items-center justify-between p-4 border-b'>
              <span className='text-lg font-bold'>
                <span className='bg-gradient-to-r from-[#FF9C15] to-[#F42026] bg-clip-text text-transparent'>PingTop</span>
                <span className='text-gray-800 ml-1'>Menu</span>
              </span>
              <button onClick={() => setSidebarOpen(false)} className='p-1.5 rounded-lg hover:bg-gray-100'>
                <svg className='w-5 h-5 text-gray-500' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M6 18L18 6M6 6l12 12' />
                </svg>
              </button>
            </div>

            {/* Nav items */}
            <div className='p-3 space-y-1'>
              {allItems.map(item => (
                <button
                  key={item.path}
                  onClick={() => handleNav(item.path)}
                  className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-all ${
                    isActive(item.path)
                      ? 'bg-gradient-to-r from-[#FF9C15] to-[#F42026] text-white shadow-md'
                      : 'text-gray-700 hover:bg-gray-100'
                  }`}
                >
                  <svg className='w-5 h-5 flex-shrink-0' fill='currentColor' viewBox='0 0 20 20'>
                    <path d={item.icon} fillRule='evenodd' clipRule='evenodd' />
                  </svg>
                  {item.label}
                </button>
              ))}
            </div>

            {/* Bottom section */}
            <div className='p-3 border-t mt-2'>
              <button
                onClick={() => { logout(); navigate('/'); }}
                className='w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-red-600 hover:bg-red-50 transition-all'
              >
                <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1' />
                </svg>
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
